// 30-day looping countdown timer
(function() {
  var CYCLE_DAYS = 30;
  // Use a fixed reference date - cycles reset every 30 days from this point
  var EPOCH = new Date('2026-06-01T00:00:00Z').getTime();
  var CYCLE_MS = CYCLE_DAYS * 24 * 60 * 60 * 1000;

  function update() {
    var now = Date.now();
    var elapsed = (now - EPOCH) % CYCLE_MS;
    var remaining = CYCLE_MS - elapsed;

    var days = Math.floor(remaining / (24 * 60 * 60 * 1000));
    var hours = Math.floor((remaining % (24 * 60 * 60 * 1000)) / (60 * 60 * 1000));
    var minutes = Math.floor((remaining % (60 * 60 * 1000)) / (60 * 1000));
    var seconds = Math.floor((remaining % (60 * 1000)) / 1000);

    var el = document.getElementById('countdown-timer');
    if (el) {
      el.textContent = days + 'd ' + hours + 'h ' + minutes + 'm ' + seconds + 's';
    }
  }

  update();
  setInterval(update, 1000);
})();
